import { useCatalogFetchers } from "@/shared/catalogs/hooks/useCatalogs";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
	setListAllParts: Function;
};

// The full inventory comes from the shared catalog, so opening this picker after another one costs
// nothing. Filtering happens in the grid, which is why the search argument is no longer used.
export const useSearchParts = ({
	setIsLoading,
	setError,
	setListAllParts,
}: Props) => {
	const { fetchPartsInventory } = useCatalogFetchers();

	return async (_partSearch?: string) => {
		setIsLoading(true);
		try {
			setListAllParts(await fetchPartsInventory());
		} catch (e: any) {
			setError(e?.message || "Error fetching the parts inventory");
		} finally {
			setIsLoading(false);
		}
	};
};
